import {takeLatest} from 'redux-saga/effects';
import * as constants from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(constants.ORDER_SYNC_BILL_NO.REQUEST, saga.orderBillNoSyncs);
    yield takeLatest(constants.ORDER_LIST_BILL_NO.REQUEST, saga.getOrdersBillNo);
}